import React from 'react';
import "../styles.scss";
import { useLanguage } from '../context/LanguageContext';

const FeaturedProjects = () => {
    const { t } = useLanguage();

    return (
        <section>
            <h1 className="text-wrap">{t.featured.title}</h1>
            <p className="text-white featured-intro">{t.featured.intro}</p>
            <div className="row g-4 featured-grid">
                {t.featured.projects.map((project) => (
                    <div className="col-lg-4" key={project.title}>
                        <article className="featured-card h-100">
                            <p className="featured-company mb-2">{project.company}</p>
                            <h2 className="featured-title mb-3">{project.title}</h2>
                            <p className="text-white-50 featured-summary">{project.summary}</p>
                            <div className="featured-pill-group">
                                {project.focus.map((item) => (
                                    <span className="featured-pill" key={`${project.title}-${item}`}>{item}</span>
                                ))}
                            </div>
                        </article>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FeaturedProjects;
